export default __webpack_public_path__ + "static/media/nosmall.f5ec6f90.svg";